import React, { useEffect, useState } from "react";
import AdminAppBar from "../adminComponents/AdminAppBar";

import StackedBarChart from "../adminComponents/chartComponents/StackBarChart";
import { useLocation } from "react-router-dom";

import {
  fetchCallCounts,
  fetchStageCounts,
} from "../Services/AnalyticsService";
import { getIcons } from "../Constant/Constant";
import TodayteamActivity from "../BOD/AnalyticsComponent/TodayteamActivity";
import teamService from "../Services/TeamService";
import { showErrorToast } from "../Constant/Notification";
import { features } from "../../config/featureConfig";
import TeamService from "../../GlobalSetupComponents/Services/TeamService";
import { department } from "../../utils/storage";
import { managementDepartmentLabel, salesDepartmentLabel } from "../../GlobalSetupComponents/Enum/DepartmentEnum";

const Analytics = () => {
  const path = "analytics";
  const icons = getIcons();
  const [activeTab, setActiveTab] = useState("overall");

  const [stagesCounts, setStagesCounts] = useState({
    naH0Hq5WlwVjlu66SyoF: 0,
    Q9JZE1p3V8dahjH8eMwl: 0,
    OeC8MZqNykSosVgiPIGx: 0,
    eg6Sa6oxnxCr6ZBz4myj: 0,
    f8ddj5YskQd26cPDcqZM: 0,
  });

  const [totalCallCounts, setTotalCallCounts] = useState([]);
  const dealStagesMap = {
    naH0Hq5WlwVjlu66SyoF: {
      icon: icons.totalSiteVisitAnalytics,
      label: "Total Site Visits",
      color: "#B77EAA",
    },
    Q9JZE1p3V8dahjH8eMwl: {
      icon: icons.totalBookingsAnalytics,
      label: "Total Booking",
      color: "#2A76AB",
    },
    OeC8MZqNykSosVgiPIGx: {
      icon: icons.totalFullyRegisteredAnalytics,
      label: "Fully Registered",
      color: "#00A86A",
    },
    eg6Sa6oxnxCr6ZBz4myj: {
      icon: icons.totalDealLostAnalytics,
      label: "Lost Deals Before Booking",
      color: "#E0A0A0",
    },
    f8ddj5YskQd26cPDcqZM: {
      icon: icons.totalDealLostAnalytics,
      label: "Lost Deals After Booking",
      color: "#E0A0A0",
    },
  };

  const [teams, setTeams] = useState([]);

  const [selectedTeam, setSelectedTeam] = useState(null);
  // const [mdTeam, setMdTeam] = useState([]);
  console.log("selectedTeam", selectedTeam);
  const userData = JSON.parse(localStorage.getItem("userData"));

  const userRole = userData?.user?.role;
  const userId = userData?.user?.uid;
  let bodTeamData = [];
  if (userRole === "BOD" || userRole === "MD") {
    bodTeamData = userData?.teamId;
  }


  const [bodTeamId, setBodTeamId] = useState(bodTeamData[0]?.id);

  const fetchTeamsData = async () => {
    try {
      // const storedTeams = await teamService.getTeamName();
      // const fetchedTeams = storedTeams.data?.teams || [];
      const storedTeams = await TeamService.getDepartmentTeamList({
        department : salesDepartmentLabel
      })
      const fetchedTeams = storedTeams.data.map((list)=>(
        {
          teamId : list.value,
          name : list.label
        }
      )) || [];
      setTeams(fetchedTeams);

      const isRestoring =
        sessionStorage.getItem("restoreFromSession") === "true";

      if (!isRestoring && fetchedTeams.length > 0) {
        setSelectedTeam(fetchedTeams[0]?.teamId);
      }
    } catch (error) {
      showErrorToast(error.response?.data || "Error fetching teams");
    }
  };

  let teamName = "";
   if(userRole === "MD" || userRole === "BOD"){
    teamName = bodTeamData.find((list)=>list.id === bodTeamId )
   }else{
    teamName = teams.find((list)=>list.teamId === selectedTeam )
   }
  console.log("teams", bodTeamData);

 console.log("teamName", teamName);
  useEffect(() => {
    if (userRole != "MD" && userRole != "BOD") {
      fetchTeamsData();
    }
    sessionStorage.removeItem("restoreFromSession");
  }, []);

  useEffect(() => {
    const storedTabData = sessionStorage.getItem("activeTab");
    if (storedTabData) {
      const parsed = JSON.parse(storedTabData);
      console.log("Parsed ", parsed);

      setActiveTab(parsed.tab);
      setSelectedTeam(parsed?.teamId);
      setBodTeamId(parsed?.mdTeamId);
      sessionStorage.setItem("restoreFromSession", "true");

      sessionStorage.removeItem("activeTab");
    }
  }, []);

  const fetchStageCountsData = async (selectedTeamId) => {
    const newStageCounts = { ...stagesCounts };
    const fetchPromises = [];

    if (userRole) {
      for (const stageId in stagesCounts) {
        if (stageId) {
          fetchPromises.push(
            fetchStageCounts(
              stageId,
              selectedTeamId,
              bodTeamId,
              userRole,
              activeTab,
              userId
            )
              .then((response) => {
                newStageCounts[stageId] = response.data.stageCount;
              })
              .catch((error) => {
                console.error(
                  `Error fetching data for stage ${stageId}:`,
                  error
                );
                newStageCounts[stageId] = 0;
              })
          );
        }
      }
    }

    await Promise.all(fetchPromises);
    setStagesCounts(newStageCounts);
  };

  useEffect(() => {
    if (userRole === "MD") {
      fetchStageCountsData(bodTeamId);
    } else {
      fetchStageCountsData(selectedTeam);
    }
  }, [activeTab]);

  const handleTeamChange = (event) => {
    setSelectedTeam(event.target.value);
    fetchStageCountsData(event.target.value);
  };

  const handleMdTeamChange = (event) => {
    setBodTeamId(event.target.value);

    console.log(event.target.value);
    fetchStageCountsData(event.target.value);
  };

  useEffect(() => {
    const fetchCallCountsData = async () => {
      try {
        const response = await fetchCallCounts(
          selectedTeam,
          bodTeamId,
          userRole,
          activeTab
        );
        console.log(response);
        setTotalCallCounts(response.data);
      } catch (error) {
        showErrorToast(error.response?.data || "Error fetching call counts");
      }
    };
    fetchCallCountsData();
  }, [bodTeamId, selectedTeam, activeTab]);

  return (
    <div>
      <AdminAppBar />
      <div className="   pt-24 bg-appGrayBackground  ">
        <div className=" px-12  ">
          <div className="flex items-center  justify-between">
            {userRole === "Admin" || userRole === "CMO" ? (
              <div
                className={`flex ${
                  activeTab === "team" ? "visible" : "invisible"
                } w-fit gap-10 items-center`}
              >
                <label
                  htmlFor="teamSelect"
                  className="w-fit text-xl font-medium"
                >
                  Team:
                </label>
                <select
                  id="teamSelect"
                  value={selectedTeam}
                  onChange={handleTeamChange}
                  className="block w-30 py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  {teams.map((team) => (
                    <option key={team.id} value={team.teamId}>
                      {team.name}
                    </option>
                  ))}
                </select>
              </div>
            ) : userRole === "MD" ? (
              <div
                className={`flex ${
                  activeTab === "team" ? "visible" : "invisible"
                } w-fit gap-10 items-center`}
              >
                <label
                  htmlFor="teamSelect"
                  className="w-fit text-xl font-medium"
                >
                  Team:
                </label>
                <select
                  id="teamSelect"
                  value={bodTeamId}
                  onChange={handleMdTeamChange}
                  className="block w-30 py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  {bodTeamData.map((team) => (
                    <option key={team.id} value={team.id}>
                      {team.name}
                    </option>
                  ))}
                </select>
              </div>
            ) : null}

            {/* )} */}
            {userRole !== "BOD" && (
              <div className="relative flex space-x-8 float-right items-center justify-center p-4">
                {/* Toggle Buttons */}
                <button
                  className={`text-lg font-normal ${
                    activeTab === "overall"
                      ? "text-black text-xl font-semibold"
                      : "text-gray-500"
                  }`}
                  onClick={() => setActiveTab("overall")}
                >
                  Overall Analytics
                </button>
                <button
                  className={`text-lg font-normal ${
                    activeTab === "team"
                      ? "text-black text-xl font-semibold"
                      : "text-gray-500"
                  }`}
                  onClick={() => setActiveTab("team")}
                >
                  Team Analytics
                </button>

                {/* Animated Underline */}
                <div
                  className={`absolute bottom-3 h-1 bg-customGreen rounded transition-all duration-300 ease-in-out`}
                  style={{
                    width: activeTab === "overall" ? "150px" : "130px", // Adjust width to match text
                    transform:
                      activeTab === "overall"
                        ? "translateX(-100px)"
                        : "translateX(75px)", // Adjust position
                  }}
                ></div>
              </div>
            )}
          </div>

          <div className="  grid grid-cols-6 gap-4  w-full  justify-around  mt-2">
            <div className="bg-[#31859D] rounded-lg p-4 h-48 shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col items-center justify-center text-white">
              <img
                className="w-10 mx-auto"
                src={icons.totalCallAnalytics}
                alt="Total Calls"
              />
              <div className="flex items-center justify-around mt-4">
                <div className="text-center">
                  <h1 className="text-xl font-bold">
                    {totalCallCounts?.simCallCount?.count || 0}
                  </h1>
                  <p className="text-sm">Total SIM Calls</p>
                </div>
     {features.ivrCalls && (
           <>
                 <hr className="w-1 h-8 bg-white mx-2" />
                 <div className="text-center">
                   <h1 className="text-xl font-bold">
                     {totalCallCounts?.ivrCallCount?.count || 0}
                   </h1>
                   <p className="text-sm">Total IVR Calls</p>
                 </div>
           </>
     )}
              </div>
            </div>
            {Object.keys(dealStagesMap).map((stageId) => (
              <div
                key={stageId}
                style={{ backgroundColor: dealStagesMap[stageId].color }}
                className={`  w-full h-48 rounded-md flex flex-col justify-center items-center gap-1 text-white`}
              >
                <img
                  className="w-10"
                  src={dealStagesMap[stageId].icon}
                  alt=""
                />
                <h1 className="text-2xl font-bold">{stagesCounts[stageId]}</h1>
                <h1 className="text-sm text-center">
                  {dealStagesMap[stageId].label}
                </h1>
              </div>
            ))}
          </div>
          <div className=" w-auto mt-6">
            {activeTab == "overall" && userRole != "BOD" ? (
              <StackedBarChart view={path} />
            ) : (
              <>
                {
                  <TodayteamActivity
                    teamId={selectedTeam}
                    mdTeamId={bodTeamId}
                    teamName={teamName}
                  />
                }
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Analytics;
